import { useMemo } from "react";
// routes
import { paths } from "src/routes/paths";
import { IconApps, IconDashboard, IconUser } from "@arco-design/web-react/icon";

// ----------------------------------------------------------------------

export function useNavData() {
    return useMemo(() => [ {
        items: [
            {
                title: "打单发货", path: paths.dashboard.shipments.root, icon: <IconDashboard style={{ fontSize: 18}}/>,
                children: [
                    { title: "创建面单", path: paths.dashboard.shipments.root },
                    { title: "面单列表", path: paths.dashboard.shipments.list },
                ]
            },
            {
                title: "账单管理", path: paths.dashboard.transaction, icon: <IconApps style={{ fontSize: 18}}/>,
            },
            {
                title: "个人中心", path: paths.dashboard.settings.profile.root, icon: <IconUser style={{ fontSize: 18}}/>,
                children: [
                    { title: "账户信息", path: paths.dashboard.settings.profile.root },
                    { title: "地址簿管理", path: paths.dashboard.settings.address_book.root },
                    { title: "账号管理", path: paths.dashboard.settings.carriers.root }
                ]
            }
        ]
    } ], []);
}
